import { useEffect, useState } from 'react'

export interface PublicationModalData {
  navContent: string
  heading: string | null
  linkToPDF: string
  HTMLNumbers: boolean
  replaceLogoEpub: string | null
  hideDefaultLogo: boolean
  publicationNumber: string | null
  publicationDate: string | null
  author: string | null
  coverPagePrintImage: string | null
  publicationHtml: string | TrustedHTML
}

const useFetchPublication = (publicationId: string, shouldFetch: boolean) => {
  const [data, setData] = useState<PublicationModalData | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!data && publicationId && shouldFetch) {
      fetchPublication()
    }
  }, [shouldFetch, publicationId])

  const fetchPublication = async () => {
    setLoading(true)
    try {
      const res = await fetch(`/api/publication/?contentid=${publicationId}`)
      const json = await res.json()

      setData(json)
    } catch (err) {
      console.error('Error fetching publication data:', err)
      setError('Error fetching publication data')
    } finally {
      setLoading(false)
    }
  }

  return {
    data,
    error,
    loading,
  }
}

export default useFetchPublication
